import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import ChariotDafPayIcon from './ChariotDafPayIcon';
import ChariotDafPayCheckedIcon from './ChariotDafPayCheckedIcon';

const useStyles = makeStyles(({ spacing }) => ({
    root: {
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    svg: {
        marginInlineEnd: spacing(0.75),
    },
}));

function CharioDafPayLogo(props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <SvgIcon
                {...props}
                viewBox={props.checked ? '0 0 28 28' : '0 0 26 26'}
                component={
                    props.checked ? ChariotDafPayCheckedIcon : ChariotDafPayIcon
                }
                className={classNames(props.className, classes.svg)}
            />
            <FormattedMessage
                id="paymentMethods.chariot"
                defaultMessage="Donor Advised Funds"
            />
        </div>
    );
}

CharioDafPayLogo.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

export default CharioDafPayLogo;
